module.exports = __webpack_public_path__ + "static/media/nb3.26e6e07c.jpg";